module.exports = __webpack_public_path__ + "media/cover_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/cover_1200.jpg
// module id = 17
// module chunks = 0